import { l, GetResourceUrl } from "@/assets/js/i18n.js";

function AppMenuItem(name, permission, icon, route, children, roleList=[]) {
  this.name = name;
  this.permission = permission;
  this.icon = icon;
  this.route = route;
  this.children = children;
  this.roleList = roleList;
}



export default {
  backend: [
    new AppMenuItem(l("总览"), null, "el-icon-s-data", "/backend/dashboard"),
    new AppMenuItem(l("现货管理"), "seller_quotation.get", "el-icon-box", "/backend/seller_quotation"),
    new AppMenuItem(l("锻件管理"), "buyer_purchase.get", "el-icon-cpu", "/backend/buyer_purchase_forging"),
    new AppMenuItem(l("求购管理"), "buyer_purchase.get", "el-icon-shopping-cart-2", "/backend/buyer_purchase_material"),
    // new AppMenuItem(l("零切管理"), "buyer_purchase.get", "el-icon-shopping-cart-1", "/backend/buyer_purchase_piece"),
    new AppMenuItem(l("机加工"), "buyer_purchase.get", "el-icon-files", "/backend/buyer_purchase_machining"),
    new AppMenuItem(l("我的收藏"), null, "el-icon-star-off", "/backend/collection"),
    new AppMenuItem(l("我的员工"), "staff.get", "el-icon-user", "/backend/staff"),
    new AppMenuItem(l("我的客户"), null, "el-icon-user-solid", "/backend/customer"),
  ],
  admin: [
    new AppMenuItem("总览", null, "el-icon-data-line", "/admin/dashboard"),
    new AppMenuItem("现货卖场", "admin_quotation.get", "el-icon-box", "/admin/quotation"),
    new AppMenuItem("锻件定制", "admin_purchase.get", "el-icon-cpu", "/admin/purchase_forging", null, [3001, 3002, 3004, 30041, 30051]),
    new AppMenuItem("原料求购", "admin_purchase.get", "el-icon-shopping-cart-2", "/admin/purchase_material", null, [3001, 3002, 3004, 30041, 30051]),
    // new AppMenuItem("零切交易", "admin_purchase.get", "el-icon-shopping-cart-1", "/admin/purchase_piece"),
    new AppMenuItem("机加工", "admin_purchase.get", "el-icon-files", "/admin/purchase_machining", null, [3001, 3002, 3004, 30041, 3006, 30061]),
    new AppMenuItem("热处理", "admin_inspect", "el-icon-magic-stick", "/admin/inspect_business"),
    new AppMenuItem("钢厂拼单", "admin_raise.get", "el-icon-copy-document", "/admin/raise"),
    new AppMenuItem("周边论坛", "admin_forum", "el-icon-help", "/admin/forum"),
    new AppMenuItem("优选好商", "website_config", "el-icon-s-shop", "/admin/good_business"),
    new AppMenuItem("平台用户", "admin_user.get", "el-icon-user", "/admin/user"),
    new AppMenuItem("认证企业", "admin_tenant.get", "el-icon-office-building", "/admin/tenant"),
    new AppMenuItem("平台管理", "website_config", "el-icon-setting", "系统", [
      new AppMenuItem("后管用户", "admin_user.get", "el-icon-user", "/admin/backend_user"),
      new AppMenuItem("文章", "admin_article.get", "el-icon-reading", "/admin/article"),
      new AppMenuItem("广告", "website_config", "el-icon-picture-outline", "/admin/banner"),
      new AppMenuItem("标签", "admin_tag.get", "el-icon-price-tag", "/admin/tag"),
      new AppMenuItem("APP", "app_edition.get", "el-icon-mobile", "/admin/app_edition"),
      new AppMenuItem("其他", "website_config", "el-icon-bangzhu", "/admin/website_config"),
    ])
  ]
}
